import { render, staticRenderFns } from "./DisassemblyDistribution.vue?vue&type=template&id=f612b8fe&scoped=true&"
import script from "./DisassemblyDistribution.vue?vue&type=script&lang=js&"
export * from "./DisassemblyDistribution.vue?vue&type=script&lang=js&"
import style0 from "./DisassemblyDistribution.vue?vue&type=style&index=0&id=f612b8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612b8fe",
  null
  
)

export default component.exports